const cssVars = {
    beige: `#fbe9c4`,
    brown: `#542200`,
    dropShadow: `.1rem .1rem .1rem #9e9e9e`,
    largeBreakPoint: `825px`,
    maxContentWidth: `35.6875rem`,
    maxHeadingWidth: `50rem`,
    midBreakPoint: `650px`,
    nunitoSans: `'Nunito Sans', sans-serif`,
    notoSerifJP: `'Noto Serif JP', serif`,
    smallBreakPoint: `370px`,
    standardTransition: `all .3s ease-in-out`,
    teal: `#008d96`,
    verticalHeaderWidth: `17.1rem`,
    xLargeBreakPoint: `970px`
};

const cssObj = {
    mixins: {
        activeHoverFocus: tempLiteral => {
            return `
              &:active,
              &:hover,
              &:focus {
                ${tempLiteral}
              }`;
        },
        figCaptionSettings: `
          color: ${cssVars.brown};
          font-family: ${cssVars.nunitoSans};
          font-size: 0.9rem;
          margin: 0 auto;
          text-align: center;
          max-width: max-content;
        `,
        graphSettings: `
          font-family: ${cssVars.notoSerifJP};
          font-size: 1rem;
          font-weight: 300;
          line-height: 1.4rem;
        `,
        gridCentered: `
          align-items: center;
          display: grid;
          justify-items: center;
        `,
        gridColsRows: (col1, col2, row1, row2) => {
            return `
              grid-column: ${col1} / ${col2};
              grid-row: ${row1} / ${row2};
            `;
        },
        inputSettings: `
          background-color: #f3f3f3;
          border: .1rem solid #c4c4c4;
          padding: .5rem;
        `,
        visuallyHidden: `
          border: 0;  
          clip: rect(0 0 0 0); 
          height: 1px; 
          margin: -1px; 
          overflow: hidden; 
          padding: 0; 
          position: absolute; 
          width: 1px;
        `
    },
    vars: cssVars
};

export default cssObj;
